import {
  __decorateClass
} from "./chunk.WHWUXFA2.js";

// src/components/jb-ref-hero/jb-ref-hero.ts
import "@bjb/bjb-web-components/dist/components/jb-breadcrumbs/jb-breadcrumbs";
import "@bjb/bjb-web-components/dist/components/jb-button/jb-button";
import "@bjb/bjb-web-components/dist/components/jb-gallery/jb-gallery";
import { Spaceable } from "@bjb/bjb-web-components/dist/mixins";
import { html, LitElement, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";

// src/components/jb-ref-hero/jb-ref-hero.scss?inline
import { css } from "lit-element/lit-element.js";
var jb_ref_hero_default = css`/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.article-meta {
  font-family: var(--theme-font-bold-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-bold-weight, 700);
}

h1, .article-meta__item-text, .article-meta__item-tag {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

h1 {
  font-size: var(--theme-typo-h1-mobile-fontsize, 2.125rem);
  font-weight: var(--theme-typo-h1-fontweight, var(--theme-font-light-weight, 300));
  line-height: var(--theme-typo-h1-mobile-lineheight, 2.75rem);
}

@media (min-width: 1281px) {
  h1 {
    font-size: var(--theme-typo-h1-desktop-fontsize, 3.125rem);
    line-height: var(--theme-typo-h1-desktop-lineheight, 4.375rem);
  }
}
.article-meta__item-text {
  font-size: var(--theme-typo-p-mobile-fontsize, 1.063rem);
  font-weight: var(--theme-typo-p-fontweight, var(--theme-font-light-weight, 300));
  line-height: var(--theme-typo-p-mobile-lineheight, 1.875rem);
}

@media (min-width: 1281px) {
  .article-meta__item-text {
    font-size: var(--theme-typo-p-desktop-fontsize, 1.188rem);
    line-height: var(--theme-typo-p-desktop-lineheight, 2.125rem);
  }
}
.article-meta__item-tag {
  font-size: var(--theme-typo-p-mini-desktop-fontsize, 0.813rem);
  font-weight: var(--theme-typo-p-mini-fontweight, var(--theme-font-light-weight, 300));
  line-height: var(--theme-typo-p-mini-desktop-lineheight, 1.25rem);
}

.article-meta {
  color: rgb(var(--rgb-primary, 20, 30, 85));
  font-size: 0.688rem;
  letter-spacing: 0.063rem;
  line-height: 1rem;
}

.sr-only {
  block-size: 1px;
  border: 0;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
}

:host {
  display: block;
}

article {
  display: flex;
  flex-direction: column;
  gap: var(--theme-spacing-lm);
}

.row {
  max-width: var(--_max-width);
  margin: 0 auto;
}
@media (min-width: 960px) {
  .row {
    max-width: unset;
  }
}
@media (min-width: 1281px) {
  .row {
    box-sizing: border-box;
    flex-basis: 83.3333333333%;
    max-width: 83.3333333333%;
    padding: 0 20px;
    width: 83.3333333333%;
    margin-left: 8.3333333333%;
  }
}
@media (min-width: 1437px) {
  .row {
    box-sizing: border-box;
    flex-basis: 66.6666666667%;
    max-width: 66.6666666667%;
    padding: 0 20px;
    width: 66.6666666667%;
    margin-left: 16.6666666667%;
  }
}

jb-breadcrumbs {
  display: block;
}

h1 {
  color: #141e55;
  margin-top: var(--theme-spacing-lm);
  margin-bottom: unset;
}

.article-meta {
  line-height: 20px;
  line-height: 1.25rem;
  display: flex;
  flex-wrap: wrap;
  margin-top: var(--theme-spacing-sm);
  gap: var(--theme-spacing-xs);
  flex-direction: column;
}
@media (min-width: 600px) {
  .article-meta {
    flex-direction: row;
    gap: var(--theme-spacing-m);
  }
}
.article-meta__item {
  display: inline;
}
.article-meta__item-tag {
  color: rgba(20, 30, 85, var(--theme-opacity-70, 0.7));
  margin-block: 0;
}
.article-meta__item-text {
  color: #141e55;
  margin-block: 0;
}

@media (min-width: 1437px) {
  jb-gallery {
    box-sizing: border-box;
    flex-basis: 83.3333333333%;
    max-width: 83.3333333333%;
    padding: 0 20px;
    width: 83.3333333333%;
    margin-left: 8.3333333333%;
  }
}

@media print {
  .article-meta {
    align-items: center;
    flex-direction: row;
  }
  jb-breadcrumbs-back-link {
    display: none;
  }
}`;

// src/components/jb-ref-hero/jb-ref-hero.ts
var JbRefHero = class extends Spaceable(LitElement) {
  _getContentSpacingProperties() {
    return {
      grid: true,
      horizontal: "full-width-sm-down",
      type: "text",
      colsMdUp: 12
    };
  }
  render() {
    return html`
      <article>
        <header class="row">
          ${this.breadcrumbs && html`
            <jb-breadcrumbs>
              ${this.breadcrumbs.backlink && html`<jb-breadcrumbs-back-link
                .link=${this.breadcrumbs.backlink.link}
                .text=${this.breadcrumbs.backlink.text}
                slot="backlink"
              ></jb-breadcrumbs-back-link>`}
              ${this.breadcrumbs.items?.map(
      (breadcrumb) => html`<jb-breadcrumbs-item
                    .link=${breadcrumb.link}
                    .text=${breadcrumb.text}
                    slot="items"
                  ></jb-breadcrumbs-item>`
    )}
            </jb-breadcrumbs>
          `}
          ${this.headline && html`<h1>${this.headline}</h1>`}
          <div class="article-meta">
            ${this.metaData?.map(
      (item) => html`<div class="article-meta__item">
                  <p class="article-meta__item-tag">${item.tag}</p>
                  <p class="article-meta__item-text">${item.text}</p>
                </div>`
    )}
          </div>
        </header>

        ${this.gallery && html`<jb-gallery
          .images=${this.gallery.images}
          .withSpacing=${this.gallery.withSpacing}
        ></jb-gallery>`}
      </article>
    `;
  }
};
JbRefHero.styles = unsafeCSS(jb_ref_hero_default);
__decorateClass([
  property({ type: Object })
], JbRefHero.prototype, "breadcrumbs", 2);
__decorateClass([
  property({ type: Object })
], JbRefHero.prototype, "gallery", 2);
__decorateClass([
  property()
], JbRefHero.prototype, "headline", 2);
__decorateClass([
  property({ type: Array })
], JbRefHero.prototype, "metaData", 2);
JbRefHero = __decorateClass([
  customElement("jb-ref-hero")
], JbRefHero);

export {
  JbRefHero
};
